import React from "react";
import styles from "./BetTablePoker20.module.css";

export default function BetTablePoker20({ data = [], onBetClick, exposures = {}, playerA = "A", playerB = "B" }) {
  // Split data into Player A (first 9) and Player B (next 9)
  const playerAData = data.slice(0, 9);
  const playerBData = data.slice(9, 18);

  // Get first bet data for min/max
  const firstBet = playerAData?.[0] || playerBData?.[0] || {};

  const formatLimit = (value) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value?.toFixed(1) || "100.0";
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (value === null || value === undefined || value === 0) return "0";
    if (Math.abs(value) >= 1000) {
      return value < 0 ? value.toFixed(0) : value.toFixed(0);
    }
    return value < 0 ? value.toFixed(2) : value.toFixed(2);
  };

  // Get exposure for a selection - handle various key formats
  const getExposure = (selection, playerName) => {
    const keys = [
      `${selection} Player ${playerName}`,
      `${selection} ${playerName}`,
      selection,
      selection?.toLowerCase(),
      selection?.trim(),
      `${selection} Player ${playerName}`.toLowerCase(),
      `${selection} ${playerName}`.toLowerCase(),
    ];

    for (const key of keys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined || betData.b === "0";
  };

  // Bet types in order - split into two groups
  const betTypesLeft = ["Winner", "One Pair", "Two Pair", "Three of a Kind", "Straight"];
  const betTypesRight = ["Flush", "Full House", "Four of a Kind", "Straight Flush"];
  const allBetTypes = [...betTypesLeft, ...betTypesRight];

  // Only show header if data exists
  const shouldShowHeader = data && Array.isArray(data) && data.length > 0;

  // Render a single table
  const renderTable = (betTypesList, startIndex) => {
    return (
      <div className={`table-responsive ${styles.betTablePoker20Wrapper}`} style={{ width: '50%' }}>
        <table className={`table table-bordered ${styles.betTablePoker20}`}>
          {shouldShowHeader && (
            <thead>
              <tr>
                <th style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }} className="box-4 min-max">
                  <div className="d-block">
                    <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Min: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstBet?.min || 100)}</div></div>
                    <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Max: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstBet?.max || 300000)}</div></div>
                  </div>
                </th>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '2px', color: '#000' }} className="text-center box-3 player-header">
                  <div style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '5px' }} className="d-block">PLAYER {playerA}</div>
                </th>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '2px', color: '#000' }} className="text-center box-3 player-header">
                  <div style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '5px' }} className="d-block">PLAYER {playerB}</div>
                </th>
              </tr>
            </thead>
          )}
          <tbody>
            {betTypesList.map((betType, localIndex) => {
              const index = startIndex + localIndex;
              const playerABet = playerAData[index] || {};
              const playerBBet = playerBData[index] || {};
              const playerAValue = playerABet?.b || "0";
              const playerBValue = playerBBet?.b || "0";
              const isPlayerASuspended = isSuspended(playerABet);
              const isPlayerBSuspended = isSuspended(playerBBet);
              const playerAExposure = getExposure(betType, playerA);
              const playerBExposure = getExposure(betType, playerB);

              return (
                <tr key={betType + index}>
                  <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white', padding: '2px' }}>
                    <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}><b>{betType}</b></div>
                  </td>

                  {/* Player A */}
                  <td
                    className={`back text-center box-3 ${isPlayerASuspended ? styles.suspended : ''}`}
                    onClick={() => !isPlayerASuspended && onBetClick && onBetClick(playerAValue, betType, playerABet, playerA)}
                    style={{
                      cursor: isPlayerASuspended ? 'not-allowed' : 'pointer',
                      backgroundColor: '#72bbef',
                      background: '#72bbef',
                      position: 'relative',
                      padding: '2px'
                    }}
                  >
                    <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                      <span className="d-block text-bold odds">{playerAValue}</span>
                      <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatExposure(playerAExposure)}</span>
                    </div>
                  </td>

                  {/* Player B */}
                  <td
                    className={`back text-center box-3 ${isPlayerBSuspended ? styles.suspended : ''}`}
                    onClick={() => !isPlayerBSuspended && onBetClick && onBetClick(playerBValue, betType, playerBBet, playerB)}
                    style={{
                      cursor: isPlayerBSuspended ? 'not-allowed' : 'pointer',
                      backgroundColor: '#72bbef',
                      background: '#72bbef',
                      position: 'relative',
                      padding: '2px'
                    }}
                  >
                    <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                      <span className="d-block text-bold odds">{playerBValue}</span>
                      <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatExposure(playerBExposure)}</span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
      {renderTable(betTypesLeft, 0)}
      {renderTable(betTypesRight, 5)}
    </div>
  );
}

